import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProjectFormDetailViewTopBar } from "./TopBar"

export const projectFormDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProjectFormDetailViewTopBar,
}
